import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=17d890a4"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports